import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-availability',
  template: `
    <span [class]="statusClass" [pTooltip]="tooltip" tooltipPosition="top">
      {{ label }}
    </span>
  `,
  styles: [`
    .in-stock { color: #5cb85c; font-weight: 600; }
    .inbound { color: #f0ad4e; }
    .call { color: #999; }
  `]
})
export class AvailabilityComponent {
  @Input() item: any;

  get label(): string {
    if (this.item?.qty > 0) return 'In Stock';
    if (this.item?.inbound_qty > 0) return 'Inbound';
    return 'Call';
  }

  get statusClass(): string {
    if (this.item?.qty > 0) return 'in-stock';
    if (this.item?.inbound_qty > 0) return 'inbound';
    return 'call';
  }

  get tooltip(): string {
    if (this.item?.inbound_qty > 0 && this.item?.first_expect_dt) {
      const d = new Date(this.item.first_expect_dt);
      return `Expected: ${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}/${d.getFullYear().toString().slice(-2)}`;
    }
    return '';
  }
}
